import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ApplicationsConfiguration } from '@rocksoft/settings-sdk';

export type ScheduledApplicationsState = EntityState<ApplicationsConfiguration>;

export function selectId(application: ApplicationsConfiguration) {
  const key: string = [
    application.locationDisplayName,
    application.environmentName,
    application.bundleIdentifier,
    application.version,
  ].join('-');
  return key;
}

export const adapter: EntityAdapter<ApplicationsConfiguration> = createEntityAdapter<ApplicationsConfiguration>({
  selectId,
});

export const initialState: ScheduledApplicationsState = adapter.getInitialState();
